export function getApiErrorMessage(error, fallback) {
  const status = error?.response?.status
  if (status === 401) return "Your session has expired. Please sign in again."
  if (status === 403) return "You do not have permission to perform this action."
  if (status === 404) return `${fallback} The requested resource is unavailable.`
  const message = error?.response?.data?.message
  return typeof message === "string" && message ? message : fallback
}
